<template>
  <div
    class="modal fade" id="reportModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">{{$t('modal.heading')}}</h3>
          <button type="button" @click="reportClose" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="button-row">
            <a class="file-btn" @click="reportClose" href="#" data-dismiss="modal">{{$t('modal.interactiveReport')}}</a>
            <a v-show="this.$i18n.locale=='en'" class="file-btn" href="https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/ab/2e/ab2ee2f0-9ffd-4e56-ba3e-014b61babf5b/zain_2021tlr_english.pdf" target="_blank">
              <i class="fa fa-file-alt"></i>{{$t('modal.downloadReport')}}<i class="fa fa-download"></i>
            </a>
            <a v-show="this.$i18n.locale=='ar'" class="file-btn" href="https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/12/a2/12a26009-d8a9-4d6c-b30a-2177edcaafa6/zain_2021tlr_arabic.pdf" target="_blank">
              <i class="fa fa-file-alt"></i>{{$t('modal.downloadReport')}}<i class="fa fa-download"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    loginOpen() {
      this.reportClose();
    }
  },
  methods: {
    reportClose: function() {
      let elementName = document.getElementsByClassName("modal")[0];
      elementName.classList.toggle("close");
      document.body.classList.toggle("no-scroll");
    }
  }
};
</script>
<style lang="scss" scoped>
.modal.close {
  top: -100% !important;
  opacity: 0 !important;
}
.modal {
  top: -100%;
  transition: 0.6s ease all;
  display: block;
  opacity: 0;
}
.modal.show {
  top: 0;
  opacity: 1;
}
.modal-dialog {
  max-width: 800px;
  width: 100%;
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  margin: 15px 0;
}
.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin:auto;
}
.modal-header {
  border: 0;
  padding: 38px;
}
.modal-content {
  border: 0;
  border-radius: 0;
}
.modal-title {
  font-size: 25px;
  color: #9053a1;
  text-transform: uppercase;
  padding: 0;
  line-height: 1.7;
  text-align: center;
  width: 100%;
}
.modal-body {
  padding-top: 0;
  padding-bottom: 50px;
}
.modal-body .file-btn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 76px;
  max-width: 420px;
  line-height: 1;
  padding: 20px 15px;
  border: 2px solid #f5f5f5;
  text-align: center;
  font-size: 18px;
  color: #cf0972;
  font-weight: 500;
  margin: auto;
  text-decoration: none;
  transition: 0.4s all ease;
}
.modal-body .file-btn:not(:last-child) {
  margin-bottom: 20px;
}
.modal-body .file-btn:hover {
  opacity: 0.7;
}
.modal-body .file-btn i {
  vertical-align: middle;
  margin-right: 15px;
}
.modal-body .file-btn i:last-child {
  margin-right: 0;
  margin-left: 15px;
}
.modal-content .close {
  opacity: 1;
  padding: 0;
  margin: 0;
  position: absolute;
  right: 40px;
  top: 40px;
  line-height: 0.6;
  z-index: 9;
  font-size: 24px;
  font-weight: 400;
}
.modal-content .close:hover,
.close:focus {
  outline: none;
}
.modal {
  text-align: center;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  margin: 15px 0;
}
.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
 margin:auto;
}
@media (max-width: 991px) {
  .modal-dialog {
    width: 98%;
    margin:auto;
  }
}
@media screen and (max-width: 600px) {
  .modal-content .close {
    right: 20px;
    top: 20px;
  }
  .modal-title {
    font-size: 17px;
    line-height: 1.4;
  }
  .modal-body .file-btn {
    font-size: 15px;
    padding: 15px 10px;
    min-height: 64px;
  }
}
// ar style

.ar {



  .modal-dialog {
    text-align: right;
  }
.modal-body .file-btn i {
  margin-left: 15px;
  margin-right:0;
}
.modal-body .file-btn i:last-child {
  margin-left: 0;
  margin-right: 15px;
}
.modal-content .close {
  left: 40px;
  right: auto;
}
  .modal-dialog {
    text-align: right;

  }

  @media screen and (max-width: 600px) {
    .modal-content .close {
      left: 20px;
      right:auto;
    }

  }
}
</style>
